 const cardEnum = {
  RECEIVE: {
    path: "/receive-card",
    name: "دریافت کارت",
  },
  ACTIVATATION: {
    path: "/card-activation",
    name: "فعال سازی کارت",
  },
  MY_PROFILE: {
    path: "/my-profile",
    name: "پروفایل من",
  },
};

export default cardEnum;